import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const ReCaptcha = forwardRef(({ onChange, onExpired }, ref) => {
  const siteKey = import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY;



  // Don't render if no site key is available
  if (!siteKey) {
    console.error('reCAPTCHA site key is missing from environment variables');
    return (
      <div className="flex justify-start my-4">
        <div className="text-red-500 text-sm border border-red-300 bg-red-50 p-3 rounded">
          ⚠️ reCAPTCHA configuration error: VITE_APP_RECAPTCHA_SITE_KEY is missing from environment variables.
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start my-4">
      <ReCAPTCHA
        ref={ref}
        sitekey={siteKey}
        onChange={onChange}
        onExpired={onExpired}
        theme="light"
      />
    </div>
  );
});

ReCaptcha.displayName = 'ReCaptcha';

export default ReCaptcha;